<template>
    <div class="video-page-wrap" :style="mainWrapClass">
        <div class="video-wrap" :style="videoWrapClass">
            <div class="video-bar"></div>
            <div class="video-comp">
                <video-component :orientation="orientation" :controller="items" :links="currentVideos" @open-modal="openModal" @chat="openChat" :style="videoCompClass"></video-component>
            </div>
            <div class="video-bar"></div>
        </div>
    </div>
</template>

<script>
import api from '@/api'
import VideoComponent from '@/components/video/VideoComponent'
export default {
    components: {
        VideoComponent
    },
    props: {
        orientation: {
            type: Boolean
        },
        videoLinks: {
            type: Array
        }
    },
    data () {
        return {
            items: []
        }
    },
    computed: {
        currentVideos () {
            return this.videoLinks.filter(el => el.ltp_code === 'info')
        }
    },
    created(){
        this.init();
    },
    mounted() {
        this.addLogicForCssFix();
    },
    methods: {
        async init() {
            let transformElements = (arr) => {
                return arr.data;
            }
            try {
                let res = await api.getInfoBoothElements();
                this.items = transformElements(res.data.res[0]);
            } catch (error) {
                this.handleError(error);
            }
        },
        openModal (link) {
            this.$emit('open-modal', link)
        },
        openChat () {
            this.EventBus.$emit('chatProp', {
                location: 'public'
            })
        }
    }
}
</script>

<style scoped lang="scss">

</style>